import { apiStore } from "../../../stores/api.store";

/**
 * Base url for `/sse/*` streams. In prod the streams go to a separate host
 * that points at the same api-gateway: browsers cap http/1.1 at 6 connections
 * per host, and a long-lived EventSource must not eat the API's share.
 */
export function getStreamApiRoot(): string {
	const apiRoot = apiStore.apiRoot;
	return apiRoot === "https://api.origoworks.se" ? "https://stream.origoworks.se" : apiRoot;
}

/**
 * Url for one SSE channel. Native EventSource cannot set headers, so the
 * token travels as a query parameter that api-gateway reads as a bearer token.
 */
export function sseChannelUrl(channel: string, accessToken: string): string {
	return `${getStreamApiRoot()}/sse/${channel}?accessToken=${encodeURIComponent(accessToken || "")}`;
}
